import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import { actionTypes } from '../../app/modules/auth';
import { Employee } from '../../app/modules/employee/models/Employee.model';
import { ModalDisplayMode } from '../../common/interfaces/modal.model';
import { Recognition } from './interfaces/recognition.model';

// TODO: figure out better way to set this for state vs action payloads
export interface RecognitionModalState {
	showModal: boolean;
	// TODO: as we implement more, these modes should be toggled
	// mode: ModalDisplayMode.Read | undefined;
	mode?: ModalDisplayMode;
	record?: Recognition;
	employee?: Employee;
	recordId?: number;
}

export interface RecognitionModalCreateState extends Pick<RecognitionModalState, 'employee'> {
	mode: ModalDisplayMode.Create;
	record?: never;
	employee: Employee;
}

export interface RecognitionModalReadState extends Pick<RecognitionModalState, 'record'> {
	mode: ModalDisplayMode.Read;
	recordId?: number;
	employee?: never;
}

export interface RecognitionModalUpdateState extends Pick<RecognitionModalState, 'record'> {
	mode: ModalDisplayMode.Update;
	recordId?: number;
	employee: Employee;
}

export interface RecognitionModalDeleteState extends RecognitionModalState {
	mode: ModalDisplayMode.Delete;
	record?: never;
	recordId: number;
	employee?: never;
}

export interface RecognitionModalPrintState extends Pick<RecognitionModalState, 'record'> {
	mode: ModalDisplayMode.Print;
	employee?: never;
}

export type RecognitionModalStateUnion =
	RecognitionModalCreateState
	| RecognitionModalReadState
	| RecognitionModalUpdateState
	| RecognitionModalDeleteState
	| RecognitionModalPrintState;

const initialState: RecognitionModalState = {
	showModal: false,
	mode: undefined,
	record: undefined,
	recordId: undefined,
	employee: undefined,
};

export const recognitionModalSlice = createSlice({
	name: 'recognitionModal',
	initialState,
	reducers: {
		show: (state, action: PayloadAction<Omit<RecognitionModalState, 'showModal'>>)=> {
			let {
				mode,
				employee,
				record,
				recordId,
			} = action.payload;
			switch (mode) {
				case ModalDisplayMode.Read:
				case ModalDisplayMode.Update:
				case ModalDisplayMode.Print:
					state.record = record;
					employee = record?.employee;
					break;
				case ModalDisplayMode.Create:
					state.record = undefined;
					state.recordId = undefined;
					break;
				case ModalDisplayMode.Delete:
					state.recordId = recordId;
				break;
			}
			state.mode = mode;
			state.employee = employee;
			state.showModal = true;
			if (recordId) {
				state.recordId = recordId;
			}
			if (!!record) {
				state.record = record;
			}
			return state;
		},
		hide: state => {
			return initialState;
		},
	},
	extraReducers: (builder) => {
		builder.addCase(actionTypes.Logout, () => initialState);
	},
});
